import PropTypes from 'prop-types';
import React, { useCallback } from 'react';

import Recommendation from './Recommendation';
import SizeChartModal from './SizeChartModal';

const PdpSizeChart = ({
  isOpen,
  closeModal,
  openModal,
  sizingRecommendation,
  modalSettings,
  sizeChart,
  handleOpenSizing,
  pdpStorytellingEnabled,
  hasSizeChartAttribute,
}) => {
  const handleClick = useCallback(() => {
    if (pdpStorytellingEnabled && hasSizeChartAttribute) {
      handleOpenSizing();
    } else {
      openModal();
    }
  }, [pdpStorytellingEnabled, hasSizeChartAttribute, handleOpenSizing, openModal]);

  return (
    <div className="PdpSizeChart mb-4">
      <Recommendation value={sizingRecommendation} onClick={handleClick} />
      <SizeChartModal
        isOpen={isOpen}
        closeModal={closeModal}
        modalSettings={modalSettings}
        sizeChart={sizeChart}
      />
    </div>
  );
};

PdpSizeChart.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  modalSettings: PropTypes.shape({}),
  openModal: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  sizingRecommendation: PropTypes.string,
  handleOpenSizing: PropTypes.func,
  pdpStorytellingEnabled: PropTypes.bool,
  hasSizeChartAttribute: PropTypes.bool,
  sizeChart: PropTypes.shape({
    title: PropTypes.string,
    supportingCopy1: PropTypes.object,
    supportingCopy2: PropTypes.object,
    sizeChartTables: PropTypes.arrayOf(
      PropTypes.shape({
        heading: PropTypes.string,
        data: PropTypes.arrayOf(
          PropTypes.arrayOf(PropTypes.shape({ value: PropTypes.string.isRequired }))
        ),
      })
    ),
  }).isRequired,
};

PdpSizeChart.defaultProps = {
  modalSettings: {},
  sizingRecommendation: '',
};

export default PdpSizeChart;
